import { app } from '../../../../app';
import { Controller } from './scim-provisioning.controller';

app.component('companyManageApplicationScimProvisioning', {
    bindings: {
        application: '<',
        companyId: '<',
        provisioningDirectory: '<'
    },
    controller: Controller,
    templateUrl: require('./scim-provisioning.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/scim-provisioning/scim-provisioning.component.js